import React, { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { AppContext } from "Context/AppContext";
import TableSkeletonElement from "Components/GMS/Products/components/TableSkeletonElement";
import CSAttributeMapping from "../components/CSAttributeMapping";
import { CSContext } from "../contexts/CSContext";
import CSConfigHeader from "../components/CSConfigHeader";
import CSSolidLineComponent from "../components/CSSolidLineComponent";
import CSCategorySelection from "../components/CSCategorySelection";
import CSVersionTable from "../components/CSVersionTable";
import CSIdentifierInput from "../components/CSIdentifierInput";
import Spinner from "Components/DesignSystem/Spinner/Spinner";
import usePagination from "Components/Common/hooks/usePagination";
import CSTablePagination from "../components/CSTablePagination";
import CSCreateButton from "../components/CSCreateButton";

const ComputedSubstitutionEditComponent: FC = (props: any) => {
  const { params } = props.match;
  const { categoryid: categoryId, uid, mode } = params;
  const appContext = useContext(AppContext);
  const readPermission = appContext.pm.checkPermission("gmssubstitution_read");
  let industryId =
    appContext &&
    appContext?.get_selected_industry() &&
    appContext?.get_selected_industry()?.id;
  const navigate = useNavigate();
  const { loading, pivotDataloading, fetchInitialState, resetState, handleDone, pivotVersionList, getPivotVersions, category } = useContext(CSContext)
  const { totalRecords, handlePageChange, updatePageSize, paginationParams, updateTotalRecords } = usePagination()
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  useEffect(() => {
    resetState()
    if (!readPermission) {
      navigate("/workspace/module/permission/denied");
      return;
    }
    appContext?.setEditInProgress(true);
    appContext?.setEditSaveHandler(() => async () => {
      await handleDone(uid, mode);
      return true;
    });
    appContext?.setEditCancelHandler(() => () => {
      resetState();
    });
    fetchInitialState(categoryId, uid);
    return () => {
      appContext?.setEditInProgress(false);
      appContext?.setEditSaveHandler(null);
      appContext?.setEditCancelHandler(null);
    }
  }, [industryId, categoryId, uid, mode]);

  useEffect(() => {
    if (category)
      getPivotVersions(category, updateTotalRecords, paginationParams)
  }, [paginationParams])

  const doneHandler = () => {
    handleDone(uid, mode)
  }

  return (
    <>
      <CSConfigHeader
        onCLickFunction={doneHandler}
        linkTo="/gms/substitutions"
        label="Computed Substitutions"
        buttonName="Done"
        mode={mode}
        showBackButton={true}
      />
      <CSSolidLineComponent />
      {loading ? (
        <TableSkeletonElement />
      ) : (
        <>
          <CSCategorySelection id={'category-selection'} categoryId={categoryId} updateTotal={updateTotalRecords} />
          {
            pivotDataloading ? (
              <div className="tw-flex tw-justify-center tw-py-10">
                <Spinner size="lg" label="Loading substitutions" showLabel data-testid="cs-edit-loading" />
              </div>
            ) :
              (mode === "create" && pivotVersionList?.length > 0 ?
                <div className="tw-ml-7">
                  <CSVersionTable
                    selectedIndex={selectedIndex}
                    setSelectedIndex={setSelectedIndex} />
                  {
                    pivotVersionList && pivotVersionList?.length > 0 ?
                      <CSTablePagination
                        paginationParams={paginationParams}
                        totalRecords={totalRecords}
                        updatePageSize={updatePageSize}
                        handlePageChange={handlePageChange} />
                      :
                      null
                  }
                  <CSCreateButton
                    selectedIndex={selectedIndex}
                    setSelectedIndex={setSelectedIndex} />
                </div>
                :
                ["edit", "create_version"].includes(mode) || pivotVersionList?.length == 0 ?
                  <>
                    <CSIdentifierInput mode={mode} />
                    <CSAttributeMapping />
                  </>
                  :
                  null)
          }
        </>
      )}
    </>
  );
};

export default ComputedSubstitutionEditComponent;
